// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetArticlePreviewImageByIdRequestModel from '../../model/get-article-preview-image-by-id-request-model';
import GetArticlePreviewImageByIdRequestDTO from '../dto/get-article-preview-image-by-id-request-dto';
import dtoSchema from '../schemas/get-article-preview-image-by-id-request-schema';

export default abstract class GetArticlePreviewImageByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetArticlePreviewImageByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetArticlePreviewImageByIdRequestDTO>): GetArticlePreviewImageByIdRequestModel;
  static toModel(dto: DeepPartial<GetArticlePreviewImageByIdRequestDTO> | undefined | null): GetArticlePreviewImageByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetArticlePreviewImageByIdRequestDTO> | undefined | null): GetArticlePreviewImageByIdRequestModel | undefined {
    return dto ? new GetArticlePreviewImageByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetArticlePreviewImageByIdRequestModel> | GetArticlePreviewImageByIdRequestModel): GetArticlePreviewImageByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetArticlePreviewImageByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetArticlePreviewImageByIdRequestModel, can not map to GetArticlePreviewImageByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
